import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function EditChild() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [successMsg, setSuccessMsg] = useState('');

  useEffect(() => {
    fetch(`https://guardiancloudcare.com/backend/api/child_details.php`)
      .then(res => res.json())
      .then(data => {
        const found = data.data.find((c: any) => String(c.id) === String(id));
        setForm(found);
        setLoading(false);
      });
  }, [id]);

  const update = (key: string, value: any) =>
    setForm((prev: any) => ({ ...prev, [key]: value }));

  const handleSave = async () => {
    const res = await fetch("https://guardiancloudcare.com/backend/api/update_child.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form)
    });

    const data = await res.json();

    if (data.success) {
      setSuccessMsg("✅ Profile updated successfully!");

      setTimeout(() => {
        navigate(`/child-profiles/${id}`);
      }, 1500);
    }
  };

  if (loading || !form) {
    return <div className="p-10 text-center text-gray-400">Loading...</div>;
  }

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-xl shadow">

      <h2 className="text-xl font-bold mb-4">Edit Child Profile</h2>

      {successMsg && (
        <div className="mb-4 p-3 bg-green-100 text-green-700 rounded-lg text-sm">
          {successMsg}
        </div>
      )}

      <div className="grid grid-cols-2 gap-4">

        {/* CHILD INFO */}
        <input value={form.firstName} onChange={(e)=>update('firstName', e.target.value)} placeholder="First Name" className="input" />
        <input value={form.lastName} onChange={(e)=>update('lastName', e.target.value)} placeholder="Last Name" className="input" />
        <input value={form.middleName} onChange={(e)=>update('middleName', e.target.value)} placeholder="Middle Name" className="input" />

        <input type="date" value={form.birthDate} onChange={(e)=>update('birthDate', e.target.value)} className="input" />
        <input type="number" value={form.age} onChange={(e)=>update('age', e.target.value)} placeholder="Age" className="input" />

        <select value={form.gender} onChange={(e)=>update('gender', e.target.value)} className="input">
          <option>Male</option>
          <option>Female</option>
        </select>
        
        <input value={form.nationality} onChange={(e)=>update('nationality', e.target.value)} placeholder="Nationality" className="input" />
        <input value={form.religion} onChange={(e)=>update('religion', e.target.value)} placeholder="Religion" className="input" />

        {/* ADDRESS */}
        <input value={form.address} onChange={(e)=>update('address', e.target.value)} placeholder="Address" className="input col-span-2" />
        <input value={form.barangay} onChange={(e)=>update('barangay', e.target.value)} placeholder="Barangay" className="input" />
        <input value={form.municipality} onChange={(e)=>update('municipality', e.target.value)} placeholder="Municipality" className="input" />
        <input value={form.province} onChange={(e)=>update('province', e.target.value)} placeholder="Province" className="input" />

        {/* SCHOOL */}
        <input value={form.schoolName} onChange={(e)=>update('schoolName', e.target.value)} placeholder="School Name" className="input" />
        <input value={form.gradeLevel} onChange={(e)=>update('gradeLevel', e.target.value)} placeholder="Grade Level" className="input" />

        {/* GUARDIAN */}
        <input value={form.guardianName} onChange={(e)=>update('guardianName', e.target.value)} placeholder="Guardian Name" className="input" />
        <input value={form.guardianRelationship} onChange={(e)=>update('guardianRelationship', e.target.value)} placeholder="Relationship" className="input" />
        <input value={form.guardianContact} onChange={(e)=>update('guardianContact', e.target.value)} placeholder="Contact" className="input" />
        <input value={form.guardianAddress} onChange={(e)=>update('guardianAddress', e.target.value)} placeholder="Guardian Address" className="input col-span-2" />

        {/* FAMILY */}
        <input value={form.fatherName} onChange={(e)=>update('fatherName', e.target.value)} placeholder="Father Name" className="input" />
        <input value={form.motherName} onChange={(e)=>update('motherName', e.target.value)} placeholder="Mother Name" className="input" />
        <input type="number" value={form.siblings} onChange={(e)=>update('siblings', e.target.value)} placeholder="Siblings" className="input" />

      </div>

      <button
        onClick={handleSave}
        className="mt-6 bg-teal-500 text-white px-6 py-2 rounded-lg hover:bg-teal-600"
      >
        Save Changes
      </button>
    </div>
  );
}